import { TagColor, BorderColor } from '../interface/common';
import {
  CustomerIdentificationLevel,
  CustomerIdentificationStatus,
} from '../interface/identifications';

export const identificationLevelTranslationMapping = {
  [CustomerIdentificationLevel.NOT_NEEDED]: 'customerIdentification:levelNotNeeded',
  [CustomerIdentificationLevel.STANDARD]: 'customerIdentification:levelStandard',
  [CustomerIdentificationLevel.ENHANCED]: 'customerIdentification:levelEnhanced',
  [CustomerIdentificationLevel.SIMPLIFIED]: 'customerIdentification:levelSimplified',
};
export const identificationStatusTranslationMapping = {
  [CustomerIdentificationStatus.DONE]: 'customerIdentification:statusDone',
  [CustomerIdentificationStatus.NOT_STARTED]: 'customerIdentification:statusNotStarted',
  [CustomerIdentificationStatus.STARTED]: 'customerIdentification:statusStarted',
};
export const identificationStatusColors = {
  [CustomerIdentificationStatus.DONE]: TagColor.GREEN,
  [CustomerIdentificationStatus.NOT_STARTED]: TagColor.RED,
  [CustomerIdentificationStatus.STARTED]: TagColor.BLUE,
};

export const identificationBorderColors = {
  [CustomerIdentificationStatus.DONE]: BorderColor.GREEN,
  [CustomerIdentificationStatus.NOT_STARTED]: BorderColor.RED,
  [CustomerIdentificationStatus.STARTED]: BorderColor.BLUE,
};
